import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onOpenContactForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header data-testid="main-nav" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-wine-950/95 backdrop-blur-xl border-b border-wine-800/30 shadow-lg shadow-wine-950/50' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <button data-testid="header-logo" onClick={() => navigate('/')} className="text-lg font-bold text-white tracking-tight hover:text-gold-400 transition-colors">
            Trademark Text Logo
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {[{ label: 'Home', id: 'home' }, { label: 'Services', id: 'services' }, { label: 'Pricing', id: 'pricing' }, { label: 'Testimonials', id: 'testimonials' }, { label: 'FAQ', id: 'faq' }].map((item) => (
              <button key={item.id} data-testid={`nav-${item.id}`} onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium text-wine-200 hover:text-gold-400 transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-gold-400 after:transition-all hover:after:w-full">
                {item.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+18005551234" className="flex items-center text-sm text-wine-300 hover:text-white transition-colors">
              <Phone className="w-3.5 h-3.5 mr-1.5" /> (800) 555-1234
            </a>
            <Button data-testid="header-get-started" onClick={onOpenContactForm} className="bg-gold-500 hover:bg-gold-400 text-wine-950 text-sm font-semibold px-5 shadow-lg shadow-gold-500/20 transition-all hover:shadow-gold-400/30">
              Get Started
            </Button>
          </div>

          <button data-testid="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-white">
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-3">
              {['Home', 'Services', 'Pricing', 'Testimonials', 'FAQ'].map((label) => (
                <button key={label} onClick={() => scrollToSection(label.toLowerCase())} className="text-sm font-medium text-wine-200 hover:text-gold-400 text-left">{label}</button>
              ))}
              <Button onClick={onOpenContactForm} className="bg-gold-500 hover:bg-gold-400 text-wine-950 text-sm font-semibold mt-2 w-full">Get Started</Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
